import "./AnimatedDiv.css";
import { useInView } from "react-intersection-observer";

export default function AnimatedDiv({
  children,
  className,
  style,
  direction = "bottom",
  triggerOnce = true,
}) {
  const { ref, inView } = useInView({
    triggerOnce: triggerOnce,
  });

  return (
    <div
      ref={ref}
      className={`${className} ${direction} hidden ${inView ? "show" : ""}`}
      style={style}
    >
      {children}
    </div>
  );
}
